import { createPrimitiveControlRenderer } from '@web-config-app/entity-form';
import { RuleCombinationJsonLogicInputControlRenderer } from '../components/controls-primitive/json-logic-input-control/rule-combination-json-logic-input-control.component';
import { isRuleCombinationJsonLogicInputControl } from '../testers/control-testers';

// we export ruleCombinationJsonLogicInputControlRenderer renderer separately for use on the EntityDetails main EntityForm, and so it can be omitted from the RuleTemplateEntity form and not included in the default renderers
export const ruleCombinationJsonLogicInputControlRenderer =
  createPrimitiveControlRenderer(
    isRuleCombinationJsonLogicInputControl,
    RuleCombinationJsonLogicInputControlRenderer,
  );
